var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('hospitality.booking.info.cart')))]),_vm._v(" "),_c('Rentals',{attrs:{"products":_vm.booking.products}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }